import React, { useContext, useState } from "react";
import { bool, func, number, string } from "prop-types";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import { TransactionInfo, TransactionSign } from "pages/_components/TransactionCard";
import FormattedDate from "pages/_components/FormattedDate";
import { formatNum } from "util/format";
import * as i18n from "util/i18n";

const DepositsSummary = ({ isTicket, title, ...props }) => {
    const { transaction = {} } = useContext(TransactionContext);
    const { data = {} } = transaction;
    const { debitAccount = {} } = data;
    const { showMoreData, isDesktop } = props;

    const {
        depositType = props.depositType,
        investCapital = props.investCapital,
        termInDays = props.termInDays,
        currency = props.currency,
        earnedInterests = props.earnedInterests,
        chargeAmount = props.chargeAmount,
        tna = props.tna,
        expirationDate = props.expirationDate,
        autoRenewalLabel = props.autoRenewalLabel,
    } = data;

    const { productType = props.productType, number: _number = props.number } = debitAccount;
    const currencyString = i18n.get(`currency.label.${currency}`);

    return isTicket ? (
        <>
            <div className="ticket__body ticket__full-width expanded">
                <div className="ticket-section three-cols-custom-data">
                    <TransactionInfo
                        withoutSpace
                        field="deposits.type"
                        i18nId={`deposit.depositTypes.${depositType}`}
                    />
                    <TransactionInfo withoutSpace field="deposits.debitAccount">
                        {`${i18n.get(`deposits.operative.account`)} ····${_number?.slice(-4)} ${productType?.slice(
                            0,
                            2,
                        )} ${currencyString}`}
                    </TransactionInfo>
                    <TransactionInfo
                        withoutSpace
                        field="deposits.investCapital"
                        value={`${currencyString} ${formatNum(investCapital, 2)}`}
                    />
                    <TransactionInfo
                        withoutSpace
                        field="deposits.earnedInterests"
                        value={`${currencyString} ${formatNum(earnedInterests, 2)}`}
                    />{" "}
                    <TransactionInfo
                        withoutSpace
                        field="deposits.chargeAmount"
                        value={`${currencyString} ${formatNum(chargeAmount, 2)}`}
                    />
                    <TransactionInfo withoutSpace field="deposits.expirationDate">
                        <FormattedDate date={expirationDate} dateFormat="DD/MM/YYYY" />
                    </TransactionInfo>
                    <TransactionInfo withoutSpace field="deposits.termInDays" value={termInDays} />
                    <TransactionInfo withoutSpace field="deposits.tnaDetail" value={`${formatNum(tna, 2)}%`} />
                    <TransactionInfo withoutSpace field="deposits.autoRenewal" value={autoRenewalLabel} />
                </div>
                <div className="ticket-section">
                    <TransactionSign isDesktop={isDesktop} showMoreData={showMoreData} />
                </div>
            </div>
        </>
    ) : (
        <div className="ticket__body expanded">
            <div className="ticket-section three-cols-custom-data">
                <TransactionInfo
                    withoutSpace
                    field="deposits.investCapital"
                    value={`${currencyString} ${formatNum(investCapital, 2)}`}
                />

                <TransactionInfo
                    withoutSpace
                    field="deposits.chargeAmount"
                    value={`${currencyString} ${formatNum(chargeAmount, 2)}`}
                />
                <TransactionInfo withoutSpace field="deposits.type" i18nId={`deposit.depositTypes.${depositType}`} />
                <TransactionInfo withoutSpace field="deposits.debitAccount">
                    {`${i18n.get(`deposits.operative.account`)} ····${_number?.slice(-4)} ${productType?.slice(
                        0,
                        2,
                    )} ${currencyString}`}
                </TransactionInfo>
                <TransactionInfo
                    withoutSpace
                    field="deposits.earnedInterests"
                    value={`${currencyString} ${formatNum(earnedInterests, 2)}`}
                />
                <TransactionInfo withoutSpace field="deposits.expirationDate">
                    <FormattedDate date={expirationDate} dateFormat="DD/MM/YYYY" />
                </TransactionInfo>
                <TransactionInfo withoutSpace field="deposits.termInDays" value={termInDays} />
                <TransactionInfo withoutSpace field="deposits.tnaDetail" value={`${formatNum(tna, 2)}%`} />
                <TransactionInfo withoutSpace field="deposits.autoRenewal" value={autoRenewalLabel} />
            </div>
        </div>
    );
};

DepositsSummary.propTypes = {
    title: string.isRequired,
    productType: string,
    number: string,
    depositType: string,
    investCapital: number,
    termInDays: number,
    currency: string,
    earnedInterests: string,
    chargeAmount: string,
    tna: string,
    expirationDate: string,
    autoRenewalLabel: bool,
    isTicket: bool,
    isDesktop: bool,
    showMoreData: bool,
    setShowMoreData: func,
};

DepositsSummary.defaultProps = {
    productType: "",
    number: "",
    depositType: "",
    investCapital: 0,
    termInDays: 0,
    currency: "",
    earnedInterests: "",
    chargeAmount: "",
    tna: "",
    expirationDate: "",
    autoRenewalLabel: false,
    isTicket: false,
    isDesktop: false,
    showMoreData: false,
    setShowMoreData: () => {},
};

export default DepositsSummary;
